import React, { useEffect, useState } from "react";
import "../styles/quiz.scss";
import "../styles/login.scss";
import Navbar from "./navbar";
import QuizGroups from "./quiz-groups";
import QuizForm from "./quiz-form";
import { deleteUserResponsesDB, getImgUrl, getUserDataDB } from "../lib/db";
import ModalProfile from "./modal-profile";
import { formStateSession, new_ } from "../lib/constants";

function Quiz({
  questionsData,
  language,
  changeLanguage,
  user,
  setUser,
  company,
  userProfile,
  setUserProfile,
  isMobile,
  isTablet,
  isDesktop,
}) {
  const [userData, setUserData] = useState();
  const [userStateForm, setUserStateForm] = useState();
  const [completedForm, setCompletedForm] = useState(false);
  const [userTypeForm, setUserTypeForm] = useState();
  const [currentQuestionsGroup, setCurrentQuestionsGroup] = useState();
  const [currentOptionsGroup, setCurrentOptionsGroup] = useState();
  const [showModalProfile, setShowModalProfile] = useState();
  const [showMenu, setShowMenu] = useState(true);

  useEffect(() => {
    let formState = sessionStorage.getItem(formStateSession);
    if (formState) {
      setUserStateForm(formState ? formState : new_);
    }
    if (formState === new_) {
      deleteUserResponses();
      setUserData({});
    } else {
      getUserData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  useEffect(() => {
    if (questionsData) {
      getImgsUrl();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questionsData]);

  useEffect(() => {
    if (userData && userData.questions && userData.options && questionsData) {
      let questionsCompleted = [];
      let optionsCompleted = [];
      // CAMBIAR PARA QUE APAREZCAN LOS ARCHIVOS DESCARGABLES
      //let totalOptions = Object.keys(questionsData.options).length / 4;
      //let totalQuestions = Object.keys(questionsData.questions).length / 2;
      let totalOptions =1
      let totalQuestions = 5;
      
      // eslint-disable-next-line array-callback-return
      Object.values(userData?.questions).map((question, key) => {
        if (question.done) {
          questionsCompleted.push(key);
        }
      });
      // eslint-disable-next-line array-callback-return
      Object.values(userData?.options).map((option, key) => {
        if (option.done) {
          optionsCompleted.push(key);
        }
      });
      if (
        questionsCompleted.length === totalQuestions &&
        optionsCompleted.length === totalOptions
      ) {
        setCompletedForm(true);
      } else {
        setCompletedForm(false);
      }

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData, questionsData]);

  const deleteUserResponses = async () => {
    if (user) {
      await deleteUserResponsesDB(user.id);
    }
  };

  const getUserData = async () => {
    if (user) {
      setUserData(await getUserDataDB(user.id));
    }
  };

  const getImgsUrl = async () => {
    Object.values(questionsData.questions).map(async (question) => {
      if (question.image) {
        question.image = await getImgUrl(question.image);
      }
    });
  };

  return (
    <div className="quiz-div">
      {user && (
        <Navbar
          setUser={setUser}
          language={language}
          changeLanguage={changeLanguage}
          company={company}
          user={user}
          setShowModalProfile={setShowModalProfile}
          setUserProfile={setUserProfile}
          isDesktop={isDesktop}
          isMobile={isMobile}
          isTablet={isTablet}
        />
      )}
      {showModalProfile && (
        <ModalProfile
          language={language}
          user={user}
          setUserProfileProp={setUserProfile}
          userProfileProp={userProfile}
          setShowModalProfile={setShowModalProfile}
        />
      )}
      {(isMobile || isTablet) && (
        <div style={{ width: "100%", display: "flex", justifyContent: "center", paddingTop: "24px" }}>
        <img
          alt="menu"
          title={showMenu ? "Hide Menu" : "Show Menu"}
          src={
            showMenu
              ? "/assets/img/icon-white-close.svg"
              : "/assets/img/icon-menu.svg"
          }
          style={{
            cursor: "pointer",
            width: showMenu ? "18px" : "24px",
            height: showMenu ? "18px" : "24px",
            transition: "0.3s ease-in-out",
          }}
          onClick={() => setShowMenu(!showMenu)}
        />
      </div>      
      )}
      <div className="quiz-body">
        {(isDesktop || (isMobile && showMenu) || (isTablet && showMenu)) && (
          <div className="quiz-groups-div">
            <QuizGroups
              language={language}
              userDataProp={userData}
              userStateForm={userStateForm}
              questionsData={questionsData}
              setCurrentQuestionsGroup={setCurrentQuestionsGroup}
              setCurrentOptionsGroup={setCurrentOptionsGroup}
              setUserTypeForm={setUserTypeForm}
              isMobile={isMobile}
              isTablet={isTablet}
              isDesktop={isDesktop}
              setShowMenu={setShowMenu}
            />
          </div>
        )}
        {(isDesktop || (isMobile && !showMenu) || (isTablet && !showMenu)) && (
          <div className="quiz-questions-div">
            <QuizForm
              language={language}
              user={user}
              userData={userData}
              userStateForm={userStateForm}
              questionsData={questionsData}
              currentQuestionsGroup={currentQuestionsGroup}
              currentOptionsGroup={currentOptionsGroup}
              userTypeForm={userTypeForm}
              setUserData={setUserData}
              completedForm={completedForm}
              setShowMenu={setShowMenu}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default Quiz;
